import React from 'react';
import { Image } from 'antd';
import classNames from 'classnames';

import { IOption } from 'modules/national-certificate';

import { MathJaxContext } from 'components';

import { useOptionState } from '../hooks';

interface IProps {
  testId?: number;
  isHorizontal?: boolean;
  optionsStyle?: string;
  options?: IOption[];
  checkedId?: number;
}

const Options: React.FC<IProps> = ({ isHorizontal = false, optionsStyle, options, checkedId }) => {
  const { getStateClass, getInnerBorderClass } = useOptionState(checkedId as number);

  return (
    <div className={classNames({ 'grid grid-cols-1 gap-1 md:grid-cols-2': isHorizontal, 'space-y-2': !isHorizontal })}>
      {options?.map((option, index) => (
        <div key={option.id} className={classNames('rounded-xl border-2', getStateClass(option))}>
          <div
            className={classNames(
              optionsStyle,
              'flex cursor-pointer items-center gap-3 rounded-xl border p-3 transition-all',
              getInnerBorderClass(option)
            )}
          >
            <span className="text-lg font-semibold text-gray-600">{String.fromCharCode(97 + index)})</span>
            <div className="min-w-0 flex-1 overflow-x-auto overflow-y-hidden">
              <p className="inline-block whitespace-pre-line text-sm text-gray-800">
                <MathJaxContext expression={option.name} />
              </p>
              {option?.image && (
                <div className="mt-2 flex justify-center">
                  <Image src={option.image} alt={option?.name || 'Test option'} loading="lazy" title="Test image" />
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Options;
